export const fmt = (n: number): string =>
  Math.round(n).toLocaleString("ru-RU");

/** Дробное как есть, до 2 знаков, без лишних нулей: 16 → "16", 8.2 → "8,2". */
export const fmtNum = (n: number): string =>
  n.toLocaleString("ru-RU", { maximumFractionDigits: 2 });

export const fmt1 = (n: number): string =>
  n.toLocaleString("ru-RU", { minimumFractionDigits: 1, maximumFractionDigits: 1 });

/** unix-секунды → "дд.мм чч:мм" в локальном времени устройства. */
export const fmtDateTimeShort = (ts: number): string => {
  const d = new Date(ts * 1000);
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(d.getDate())}.${p(d.getMonth() + 1)} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

/** Проценты KPI с одним знаком и пробелом перед «%»: 118.58 → "118,6 %". */
export const fmtPct1 = (n: number): string => `${fmt1(n)} %`;

/** unix-секунды → "дд.мм чч:мм" по киевскому времени (публикации из панели в UTC). */
export const fmtKyivDateTime = (ts: number): string => {
  const parts = new Intl.DateTimeFormat("ru-RU", {
    timeZone: "Europe/Kyiv", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false,
  }).formatToParts(new Date(ts * 1000));
  const get = (t: string) => parts.find(p => p.type === t)?.value ?? "";
  return `${get("day")}.${get("month")} ${get("hour")}:${get("minute")}`;
};

const MONTHS_RU = ["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"];
const MONTHS_UK = ["Січень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"];

/** "2026-10" → "Октябрь 2026" / "Жовтень 2026". */
export const fmtMonth = (month: string, lang: "ru" | "uk"): string => {
  const [y, m] = month.split("-").map(Number);
  const names = lang === "uk" ? MONTHS_UK : MONTHS_RU;
  return `${names[(m ?? 1) - 1] ?? month} ${y}`;
};
